// remember to update confluence page after modifying this file
// https://dop-orange.atlassian.net/wiki/spaces/WUWA/pages/1827602540/Nju+Tagging+DataLayer

interface IPushBeginCheckoutEventGA4Props {
  productId: string;
  productPrice: number;
  downloadSpeed?: string;
  offerCategory: string;
  subscriptionCategory: string;
  numberCount: number;
}

export function pushBeginCheckoutEventGA4({
  productId,
  numberCount,
  productPrice,
  downloadSpeed,
  offerCategory,
  subscriptionCategory,
}: IPushBeginCheckoutEventGA4Props) {
  if ("dataLayer" in window) {
    window.dataLayer.push({
      event: "begin_checkout",
      ecommerce: {
        currency: "PLN",
        value: productPrice * numberCount,
        coupon: "",
        items: [
          {
            item_id: productId,
            item_name:
              offerCategory === "Internet stacjonarny"
                ? "Nju internet stacjonarny"
                : "Nju subskrypcja",
            affiliation: "",
            coupon: "",
            discount: 0,
            index: 0,
            item_brand: "Nju",
            item_category: offerCategory,
            item_category2: subscriptionCategory,
            item_category3: downloadSpeed ? `${downloadSpeed} Mb` : " ",
            item_category4: `${offerCategory}/${subscriptionCategory}`,
            item_variant: String(numberCount),
            item_list_name: "",
            location_id: "",
            price: productPrice,
            quantity: numberCount,
          },
        ],
      },
    });
  }
}
